module.exports = __webpack_public_path__ + "static/tshirts/tshirt-3-b61f5920ae3aa53bea219abbe02352a5.jpg";